import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RequestOptions, Headers } from '@angular/http';
import { List } from 'immutable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { Adjustment } from '../models/adjustment';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { AppAuthHttpService } from '../../http/app.auth.http.service';

@Injectable()
export class AdjustmentHttpService {

  private eventsUrl: string = this.environment.baseUrl + '/api/events';
  private adjustmentUrl: string = this.eventsUrl + '/adjustments';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  addAdjustment(adjustment: Adjustment): Observable<Adjustment> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.adjustmentUrl, JSON.stringify(adjustment.toJS()), options)
      .map((response) => {
        return response.json() as Adjustment;
      })
      .catch((error: any) => {
        this.responseUtilService.handleError(error);
        return Observable.throw(error);
      })
      .share();
  }

  getAdjustments(eventId: number): Observable<List<Adjustment>> {
    return this.http.get(`${this.eventsUrl}/${eventId}/adjustments`)
      .map(response => List(response.json().map(element => new Adjustment(element))))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  deleteAdjustment(adjustmentId: number): Observable<any> {
    const url = `${this.adjustmentUrl}/${adjustmentId}`;
    return this.http.delete(url)
      .catch(response => this.responseUtilService.handleError(response)).share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/adjustment.http.service.ts